import { useGetMenuCategoriesIconsQuery } from "@me-team/host/main/menu/graphql/menu.hooks";

export const useMenuCategoryIcons = (currentCompanyId: string | null) => {
    const { data } = useGetMenuCategoriesIconsQuery({
        variables: { companyId: Number(currentCompanyId) },
        skip: !currentCompanyId,
        context: { errorType: "global" },
    });

    return data?.user?.company?.menuCategoryIconList ?? [];
};
